import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import './proposalCard.css';

const ProposalCard = ({
    provider_name,
    is_pro_provider,
    avatar,
    rating_all_together,
    reviews_all_together,
    years_of_experience,
    project_id,
    lead_purchased_id,
    provider_phone_number,
    provider_email,
    is_proposal_requested,
    unavailable_user,
    is_available,
    provider_deleted,
    provider_contacted_date
}) => {
    const dispatch = useDispatch();
    const redirectData = {
        pathname: `/bid-details/${project_id}/${lead_purchased_id}/lead`,
    };

    return (
        <div className="ec-card__wrap position-relative" style={{maxWidth: "600px", margin: "0 auto"}}>
            <div className="ec-ip__ncard">
                <Link className="w-100" to="#" onClick={(e) => e.preventDefault()}>
                    <div className="ec-ip__ncard-header">
                        <div className="ec-ip__ncard-header-left">
                            <img 
                                src={(avatar && avatar.length > 0) ? avatar : "/assets/images/New-files/default-card-img-a.png"} 
                                alt="" 
                                className="ec-ip__ncard-header-avatar" 
                            />
                            <div className="ec-ip__ncard-header-data">
                                <div className="ec-ip__ncard-header-title-wrap">
                                    <p className="ec-ip__ncard-header-data-title">{provider_name}</p>
                                    {is_pro_provider && <span className="ec-ip__ncard-header-data-badge">Pro+</span>}
                                </div>
                                <div className="ec-ip__ncard-header-data-rating">
                                    <div className="rating-num">
                                        <span>{rating_all_together}</span>
                                        <span className="ml-1">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="#FFD700">
                                                <path
                                                    d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                                            </svg>
                                        </span>
                                    </div>
                                    <div className="rating-count">{reviews_all_together} ratings</div>
                                    <div className="rating-years">{years_of_experience}+ years</div>
                                </div>
                            </div>
                        </div>
                        <div className="ec-ip__ncard-header-right">
                            <div className="bid-date">{provider_contacted_date}</div>
                            <div className="contact-status">
                                <p>Contacted</p>
                                <img src="/assets/images/New-files/contact-card.svg" alt="" />
                            </div>
                        </div>
                    </div>
                </Link>

                <div className="contact-buttons">
                    <button 
                        onClick={() => { window.location.href = `tel:${provider_phone_number}` }}
                        className="phone-button"
                    >
                        <span>{provider_phone_number}</span>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/>
                        </svg>
                    </button>

                    <button
                        onClick={() => {
                            window.location.href = `sms:${provider_phone_number}?&body=I found your profile on EasyBids and want to discuss my project with you.`
                        }}
                        className="sms-button"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12z"/>
                        </svg>
                        <span>SMS</span>
                    </button>

                    <button
                        onClick={() => {
                            window.open(`mailto:${provider_email}?subject=Project Inquiry&body=I found your profile on EasyBids and want to discuss my project with you`, '_blank');
                        }}
                        className="email-button"
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path
                                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                        </svg>
                        <span>Email</span>
                    </button>
                </div>

                <div className="ec-ip__ncard__footer">
                    {!is_proposal_requested ? (
                        <Link to="#" onClick={(e) => e.preventDefault()} className="proposal-button disabled">
                        No Bids Submitted
                        </Link>
                    ) : (
                        <Link to={redirectData} className="proposal-button">
                            Proposal Requested
                        </Link>
                    )}
                </div>
            </div>
            
            {(unavailable_user || !is_available || provider_deleted) && (
                <div className="provider-overlay">
                    <div className="overlay-text">
                        This provider is no longer available.
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProposalCard;